import { useEffect, useState } from "react";
import { Image as ImageAntd, Spin } from "antd";
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import ImageDefault from "../../../assets/svg/item-iamge-default.png";

import axios from '../../../utils/axios'
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import LoadingGlobalComp from "../../Commons/Loading";

const Thumbnail = ({ url, token }: { url: any; token: string }) =>
{
      const [imgSrc, setImgSrc] = useState<string>();

      const staticConfig = localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '';

      const parsedConfig = JSON.parse(staticConfig);
      const authMethod = parsedConfig.REACT_APP_AUTHENTICATION_METHOD;




      let searchState = useSelector((state: RootState) => state.search);
      let providerId = useSelector(
            (state: RootState) => state.mapTasking.providerId
      );
      // @ts-ignore
      let loading = searchState[`loading_provider_${providerId}`];

      useEffect(() =>
      {
            setImgSrc(ImageDefault);
            if (authMethod !== "COOKIES")
            {
                  const fetchImage = async () =>
                  {
                        try
                        {
                              const res = await axios.get(url, {
                                    responseType: "blob",
                              });

                              if (res.status !== 200)
                              {
                                    setImgSrc(ImageDefault);
                                    return;
                              }

                              const blob = res.data;
                              setImgSrc(URL.createObjectURL(blob));
                        } catch (e)
                        {
                              setImgSrc(ImageDefault);
                        }
                  };
                  fetchImage();

            }

      }, [url, token, authMethod]);

      return authMethod !== "COOKIES" ? (

            <ImageAntd
                  src={imgSrc}
                  alt="thumbnail"
                  className="h-full"
                  // placeholder={
                  //       <ImageAntd
                  //             className="rounded-sm !w-[42px] !h-[42px]"
                  //             preview={false}
                  //             src={ImageDefault}
                  //       />
                  // }
                  placeholder={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                              {/* <Spin size="large" /> */}
                              <LoadingGlobalComp />
                        </div>
                  }
                  preview={false}
                  fallback={ImageDefault}
            />
      ) : (
            <ImageAntd
                  loading="lazy"
                  // width={42}
                  className="h-full"
                  src={
                        url || ImageDefault
                  }
                  alt="img item"
                  onError={(e: any) =>
                  {
                        e.target.src = ImageDefault;
                  }}
                  // placeholder={
                  //       <ImageAntd
                  //             className="rounded-sm img-card-item-catalog-search-drawer !min-w-[42px] !h-[42px] !w-[42px] !max-h-[42px] !max-w-[42px]"
                  //             preview={false}
                  //             src={ImageDefault}
                  //             width={42}
                  //       />
                  // }
                  placeholder={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                              {/* <Spin size="large" /> */}

                              <LoadingGlobalComp />
                        </div>
                  }
                  preview={false}

                  fallback={ImageDefault}
            />
      );
};

export default Thumbnail
